import { Constants, Enum } from '@examdojo/supabase';

export type UserOrigin = Enum<'user_origin'>;

export const USER_ORIGINS = Constants.public.Enums.user_origin;
